import { useAppContext } from './AppContext';
import Alert from './components/Alert';

export default function ErrorMessage() {
  const app = useAppContext();

  if (app.error) {
    return <>
      <Alert variant="red">
        <p className="mb-3">{app.error.message}</p>
          { app.error.debug ?
            <pre className="alert-pre border bg-light p-2"><code>{app.error.debug}</code></pre>
            : null
          }
      </Alert>
    </>;
  }

  return null;
}